var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { action: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submitData.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "p-8 sm:p-6" },
        [
          !_vm.modalData
            ? _c(
                "sw-input-group",
                {
                  attrs: {
                    label: _vm.$t("documents.type"),
                    error: _vm.typeError,
                    required: "",
                  },
                },
                [
                  _c("sw-select", {
                    staticClass: "mt-2",
                    attrs: {
                      options: _vm.document_types,
                      searchable: true,
                      "show-labels": false,
                      "allow-empty": false,
                      invalid: _vm.$v.selectedTypeDocument.$error,
                      placeholder: "Tapez ou cliquez pour choisir un type",
                      label: "name",
                    },
                    model: {
                      value: _vm.selectedTypeDocument,
                      callback: function ($$v) {
                        _vm.selectedTypeDocument = $$v
                      },
                      expression: "selectedTypeDocument",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "sw-input-group",
            {
              attrs: {
                label: _vm.$t("documents.date"),
                error: _vm.dateError,
                required: "",
              },
            },
            [
              _c("VueDatePicker", {
                attrs: {
                  "fullscreen-mobile": "",
                  "allowed-dates": _vm.allowedDates,
                  placeholder: "Cliquez et choisissez une date",
                },
                model: {
                  value: _vm.date_delivrance,
                  callback: function ($$v) {
                    _vm.date_delivrance = $$v
                  },
                  expression: "date_delivrance",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "sw-input-group",
            {
              attrs: {
                label: _vm.$t("estimates.file"),
                required: "",
                error: _vm.fileError,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "relative flex items-center justify-center h-28 p-10 bg-transparent border-2 border-gray-200 border-dashed rounded-md image-upload-box",
                  attrs: { id: "receipt-box" },
                },
                [
                  _vm.attachment
                    ? _c("img", {
                        staticClass: "absolute opacity-100 preview-logo",
                        staticStyle: {
                          "max-height": "80%",
                          animation: "fadeIn 2s ease",
                        },
                        attrs: { src: _vm.attachment },
                      })
                    : _c(
                        "div",
                        { staticClass: "flex flex-col items-center" },
                        [
                          _c("cloud-upload-icon", {
                            staticClass:
                              "h-5 mb-2 text-xl leading-6 text-gray-500",
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-xs leading-4 text-center text-gray-500",
                            },
                            [
                              _vm._v(
                                "\n              Cliquez ici et \n                "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "cursor-pointer text-primary-500",
                                  attrs: { id: "pick-avatar" },
                                },
                                [_vm._v("choisissez")]
                              ),
                              _vm._v(
                                "\n                un fichier\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                ]
              ),
              _vm._v(" "),
              _c("sw-avatar", {
                attrs: {
                  "preview-avatar": _vm.attachment,
                  "enable-cropper": false,
                  trigger: "#receipt-box",
                },
                on: { changed: _vm.onChange },
                scopedSlots: _vm._u([
                  {
                    key: "icon",
                    fn: function () {
                      return [
                        _c("cloud-upload-icon", {
                          staticClass:
                            "h-5 mb-2 text-xl leading-6 text-gray-400",
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "z-0 flex justify-end p-4 border-t border-gray-200 border-solid border-modal-bg",
        },
        [
          _c(
            "sw-button",
            {
              staticClass: "mr-3 text-sm",
              attrs: { type: "button", variant: "primary-outline" },
              on: { click: _vm.closeDocumentModal },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("general.cancel")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "sw-button",
            {
              attrs: {
                variant: "primary",
                type: "submit",
                loading: _vm.isLoading,
              },
            },
            [
              !_vm.isLoading
                ? _c("save-icon", { staticClass: "mr-2" })
                : _vm._e(),
              _vm._v(
                "\n      " +
                  _vm._s(
                    !_vm.isEdit
                      ? _vm.$t("general.save")
                      : _vm.$t("general.update")
                  ) +
                  "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }